import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/product/$slug")({
  component: () => <Outlet />,
});
